module.exports = {"360602001":"江边街道","360602002":"交通街道","360602003":"东湖街道","360602004":"梅园街道","360602005":"四青街道","360602006":"白露街道","360602100":"童家镇","360602200":"夏埠乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360602.json
// module id = 1394
// module chunks = 0